export default "__VITE_ASSET__4f266ef8__"